import { useAuth0 } from "@auth0/auth0-react";

/**
 * HomePage — the logged-out login gate. Once authenticated, App routes the
 * user into the AppShell instead of this page.
 */
export function HomePage(): JSX.Element {
  const { isLoading, loginWithRedirect } = useAuth0();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <p className="text-ink">Caricamento…</p>
      </div>
    );
  }

  return (
    <main className="mx-auto flex h-full max-w-3xl flex-col justify-center px-6 py-12">
      <h1 className="font-mono text-3xl font-semibold text-brand">CME Studio</h1>
      <p className="mt-2 text-ink/80">
        Analisi gare d&apos;appalto · Computo Metrico Estimativo · Knowledge Base multi-tenant.
      </p>

      <div className="mt-8 rounded-lg border border-line bg-white p-6 shadow-sm">
        <p className="text-sm text-ink/70">Accedi per continuare.</p>
        <button
          type="button"
          onClick={() => loginWithRedirect()}
          className="mt-4 rounded bg-brand px-4 py-2 text-sm font-medium text-white hover:bg-brand/90"
        >
          Accedi
        </button>
      </div>
    </main>
  );
}
